var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.333313C6.07167 0.333313 0.833336 5.57165 0.833336 12C0.833336 18.4283 6.07167 23.6666 12.5 23.6666C18.9283 23.6666 24.1667 18.4283 24.1667 12C24.1667 5.57165 18.9283 0.333313 12.5 0.333313ZM18.0767 9.31665L11.4617 15.9316C11.2983 16.095 11.0767 16.1883 10.8433 16.1883C10.61 16.1883 10.3883 16.095 10.225 15.9316L6.92334 12.63C6.585 12.2916 6.585 11.7316 6.92334 11.3933C7.26167 11.055 7.82167 11.055 8.16 11.3933L10.8433 14.0766L16.84 8.07998C17.1783 7.74165 17.7383 7.74165 18.0767 8.07998C18.415 8.41831 18.415 8.96665 18.0767 9.31665Z",
    fill: "#3FA92F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.678ff7839c2be9804c4599b33264adbe.svg";
export { ForwardRef as ReactComponent };